import { render, staticRenderFns } from "./UberTripDetails.vue?vue&type=template&id=13bbb2ac&scoped=true&"
import script from "./UberTripDetails.vue?vue&type=script&lang=js&"
export * from "./UberTripDetails.vue?vue&type=script&lang=js&"
import style0 from "./UberTripDetails.vue?vue&type=style&index=0&id=13bbb2ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bbb2ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VSelect,VSpacer,VTextarea})
